var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showIframe)?_c('admin-iframe',{attrs:{"src":_vm.remoteSrc}}):_c('Reject080List')}
var staticRenderFns = []

export { render, staticRenderFns }